module.exports = __webpack_public_path__ + "img/adress.52101166.png";